import { render, staticRenderFns } from "./SharingSummaryCard.vue?vue&type=template&id=5a3df8d8&scoped=true&"
import script from "./SharingSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./SharingSummaryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3df8d8",
  null
  
)

export default component.exports